import { TableCell } from '@mui/material';
import { Redemption, TermBond } from '../debt-service-page.tsx';
import DragAndDropRow from './drag-and-drop-row.tsx';
import moment from 'moment';
import formatter from "../../../tools/formatter.js";
import useDealBuilderResultStore from '../../../stores/deal-builder-result.store.ts';
import { DealBuilder } from '../../services/deal-builder.ts';
import MaturityPicker from './maturity-picker.tsx';
import { DebtServiceRow } from '../../services/utils/new-debt-service.utils.ts';
import CurrencyInput from './currency-input.tsx';

type RedemptionRowProps = {
  builder: DealBuilder,
  redemption: Redemption,
  bond: TermBond,
  debtServiceRow: DebtServiceRow | undefined,
  showCapitalizedInterest: boolean,
  border: boolean,
}

export default function RedemptionRow({ builder, bond, debtServiceRow, redemption, showCapitalizedInterest, border }: RedemptionRowProps) {
  const { setDealBuilderService } = useDealBuilderResultStore();

  return (
    <DragAndDropRow 
      dragging={false} 
      onDragOver={() => {}}
      indicator="none"
      sx={{
        "& td": {
          ...(!border ? { borderBottom: "none !important" } : {}),
        }
      }}
    >
      <TableCell>
        <MaturityPicker
          format="MM/DD/YYYY"
          value={moment(redemption.date)}
          firstCouponDate={builder.firstCouponDate}
          disabled={true}
          onChange={() => {}}
        />
      </TableCell>
      <TableCell align="right">
        <CurrencyInput
          className={"switch-db-0"}
          value={redemption.amount}
          startAdornment="$"
          size="small"
          locked={redemption.locked}
          onLockedChange={async (val) => {
            redemption.locked = val;
            builder.updateDebtService();
            setDealBuilderService(builder);
            await builder.updateProduction(builder.bonds);
            setDealBuilderService(builder);
          }}
          onValidChange={async (value) => {
            const newPrincipal = value * 1000;
            const oldPrincipal = redemption.amount;
            if (oldPrincipal === newPrincipal || oldPrincipal === value) return;
            const diff = newPrincipal - oldPrincipal ;
            builder.totalTargetParAmount += diff;
            redemption.amount = newPrincipal;
            redemption.locked = true;
            builder.updateDebtService();
            setDealBuilderService(builder);
            await builder.updateProduction(builder.bonds);
            setDealBuilderService(builder);
          }}
          isValueValid={(value) => {
            const valid = (value * 1000) % builder.denomination === 0;
            if(valid) return { valid: true };
            return { valid: false, error: "The principal must be divisible by the denomination." };
          }}
        />
      </TableCell>
      <TableCell align="right">
        <CurrencyInput
          className={"switch-db-1"}
          decimalScale={3}
          value={bond.coupon * 100}
          endAdornment="%"
          size="small"
          locked={bond.lockedCoupon}
          disabled={true}
          onLockedChange={(val) => {
            bond.lockedCoupon = val;
            builder.updateDebtService();
            setDealBuilderService(builder);
          }}
          onValidChange={() => {}}
          isValueValid={() => ({ valid: true })}
        />
      </TableCell>


      {debtServiceRow ? (
        <>
          <TableCell align="right">{formatter.money(debtServiceRow.accInterest, false)}</TableCell>
          {showCapitalizedInterest && (
            <TableCell align="right">
              ({formatter.money(debtServiceRow.capitalizedInterest, false)})
            </TableCell>
          )}
          <TableCell align="right">{formatter.money(debtServiceRow.debtService, false)}</TableCell>
          <TableCell align="right">{debtServiceRow.annualDS ? formatter.money(debtServiceRow.annualDS, false) : "-"}</TableCell>
        </>
      ) : (
        <>
          <TableCell align="right"></TableCell>
          {showCapitalizedInterest && <TableCell align="right"></TableCell>}
          <TableCell align="right"></TableCell>
          <TableCell align="right"></TableCell>
        </>
      )}

      <TableCell align="center"> </TableCell>
    </DragAndDropRow>
  );
};
